<ion-icon
  [ngClass]="class"
  [color]="color"
  [ios]="useDefault ? '' : name + ''"
  [md]="useDefault ? '' : name + '-sharp'"
  [name]="useDefault ? name : ''"
  >
</ion-icon>
